import React, { memo, useCallback } from 'react'

import { setLvDrawer } from '../../../redux/drawerSlice'
import { useAppDispatch } from '../../../redux/hooks'

interface LvDetailDrawerLinkProps {
  text?: React.ReactNode
  className?: string
  lvCode?: string | number
  lvNumber?: string | number
}

export const LvDetailDrawerLink: React.FC<LvDetailDrawerLinkProps> = memo(
  props => {
    const dispatch = useAppDispatch()

    const handleOnClick = useCallback(
      (e: { preventDefault: () => void }) => {
        e.preventDefault()

        if (!props.lvCode || !props.lvNumber) return

        dispatch(
          setLvDrawer({
            lvNumber: `${props.lvNumber}`,
            lvCode: `${props.lvCode}`,
          })
        )
      },
      [dispatch, props.lvCode, props.lvNumber]
    )

    if (!props.lvCode || !props.lvNumber) {
      return null
    }

    return (
      <a
        href="#"
        onClick={handleOnClick}
        title={`Zobrazit náhled LV v postranním panelu`}
        className={props.className}
      >
        {props.text || props.lvNumber}
      </a>
    )
  }
)
